import {useEffect, useState, useContext} from 'react';
import '../registration-options/registration-options.component.scss';
// import biometric from '../../../assets/images/govid-logo.png';
import twoIdentefication from '../../../../assets/icons/two-identefication.svg';
import biometricPasport from '../../../../assets/icons/biometric-pasport.svg';
import biometricId from '../../../../assets/icons/biometric-id.svg';
import LoginContext from '../../../../store/login-context';

declare var _siteSettings: any;
declare function Translate(key: string): string;
declare var _loginMethodIsraelSmartCardUrl;
declare var _loginMethodPreRegCheckUrl;


function ToggleTwoIdentefication(props) {
    return(
        <div className={props.showListTi ? "displaySetBlock": "displaySetNone"}>
            <ul className='regUL'>
                <li className='regLI'>{Translate(translateText[12].label)}</li>                
                <li className='regLI'>{Translate(translateText[14].label)}</li>
                <li className='regLI'>{Translate(translateText[15].label)}</li>
                <li className='regLI'>{Translate(translateText[16].label)}</li>  
            </ul>
        </div>
    );
}

function ToggleBiometricPassport(props) {
    return(
        <div className={props.showListBp ? "displaySetBlock": "displaySetNone"}>
            <div className='biometricPassportInfo'>{Translate(translateText[19].label)}</div>
        </div>
    );
}

function ToggleTwoIdenteficationMobile(this: any, props) {
    const ctx = useContext(LoginContext);

    const[showListTiMobile,setshowListTiMobile] = useState(false); 
    
    useEffect(() => {
        setshowListTiMobile(props.showListTiMobile);
    },[props.showListTiMobile]);
            
    var closeMobilePopupTI = () => {
        setshowListTiMobile(false);
        props.onCloseClicked();
    }

    const handleTwoIdnClick = () => {        
        window.location.href =  _siteSettings.signupLink + 
                                            "&userid=" + ctx.PreRegUser[0] +
                                            "&usermail=" + ctx.PreRegUser[1] + 
                                            "&userphone=" + ctx.PreRegUser[2] 
    };

    return(
        <div className={props.showListTiMobile ? "displaySetBlock": "displaySetNone"}>
            <div className='mobilePopupTwoIdentification'>
                <div className='popupBody'>
                    <div className='closePopup' onClick={closeMobilePopupTI}></div>
                    <div className='mobileDivImage'>
                        <img className='mobileImage' src={twoIdentefication}></img>
                    </div>
                    <div className='registraionOption'>
                        <h3>{Translate('N_General_SignUp_title_4')}</h3>
                        <div className='poupContent'>
                            <ul className='regUL'>
                                <li className='regLI'>{Translate(translateText[12].label)}</li>                
                                <li className='regLI'>{Translate(translateText[14].label)}</li>
                                <li className='regLI'>{Translate(translateText[15].label)}</li>
                                <li className='regLI'>{Translate(translateText[16].label)}</li> 
                            </ul>
                        </div>                               
                    </div>
                    <button onClick={handleTwoIdnClick} className='btn btn-primary mobileBtn'>
                        {Translate(translateText[0].label)}
                    </button>
                    <button className='btn mobileBtn buttonMainColor marginTop marginBottom' onClick={closeMobilePopupTI}>
                        {Translate('N_General_back')} 
                    </button>                    
                </div>
            </div>
        </div>
    );  
}

function ToggleBiometricPassportMobile(this: any, props){
    const[showListBpMobile,setshowListBpMobile] = useState(false); 
    
    useEffect(() => {
        setshowListBpMobile(props.showListBpMobile);
    },[props.showListBpMobile]);
            
    var closeMobilePopupBP = () => {
        setshowListBpMobile(false);
        props.onCloseClicked();
    }
    
        return(
            <div className={props.showListBpMobile ? "displaySetBlock": "displaySetNone"}>
                <div className='mobilePopupTwoIdentification'>
                    <div className='popupBody'>
                        <div className='closePopup' onClick={closeMobilePopupBP}></div>
                        <div className='mobileDivImage'>
                                <img className='mobileImage' src={biometricPasport}></img>
                            </div>
                            <div className='registraionOption'>
                                <h3>{Translate(translateText[8].label)}</h3>
                                <div className='poupContent'>
                                    <div className='biometricPassportInfo'>{Translate(translateText[19].label)}</div>
                                </div>
                               

                            </div>
                            <button onClick={()=>window.location.href = _siteSettings.signupLinkBiometricP} className='btn btn-primary mobileBtn'>
                                {Translate(translateText[0].label)}
                            </button>
                            <button className='btn mobileBtn buttonMainColor marginTop marginBottom' onClick={closeMobilePopupBP}>
                                חזרה  
                            </button>
                    
                    </div>
                </div>
            </div>
        );
    
}

export let translateText = [
    {
        label: 'N_General_SignUp_butten',
        value: 'link',
    },
    // 1
    {
      label: 'N_General_SignUp_lobby_title_1',
      value: 'general header two identefication',
    },
    // 2
    {
        label: 'N_General_SignUp_lobby_info_4',
        value: 'two identefication options',
    },
    {
        label: 'N_General_SignUp_lobby_info_5',
        value: 'preLink',
    },
    {
        label: 'N_General_SignUp_lobby_info_5',
        value: 'preLink',
    },
    {
        label: 'N_General_SignUp_lobby_info_5',
        value: 'preLink',
    },
    {
        label: 'N_General_SignUp_lobby_info_5',
        value: 'preLink',
    },
    {
        label: 'N_General_SignUp_lobby_info_5',
        value: 'preLink',
    },
    // 8
    {
      label: 'N_General_SignUp_lobby_title_2',
      value: 'sub header'
    },
    // 9
    {
      label: 'N_General_SignUp_lobby_title_3',
      value: 'paragraph',
    },
    // 10
    {
        label: 'N_General_SignUp_lobby_info_5',
        value: 'preLink',
    },
    // 11
    {
        label: 'N_General_SignUp_lobby_butten_1',
        value: 'link',
    },
    // 12
    {
        label: 'N_General_SignUp_lobby_info_5',
        value: 'israeli passport'
    },
    // 13
    {
        label: 'N_General_SignUp_lobby_info_6',
        value: 'israeli ID'
    },
    // 14
    {
        label: 'N_General_SignUp_lobby_info_7',
        value: 'israeli Immigrant certificate'
    },
    // 15
    {
        label: 'N_General_SignUp_lobby_info_8',
        value: 'two questions'
    },
    // 16
    {
        label: 'N_General_SignUp_lobby_info_9',
        value: 'credit card'
    },
    // 17
    {
        label: 'N_General_SignUp_kupa_0',
        value: 'HMO'
    },
    // 18
    {
        label: 'N_General_SignUp_lobby_info_11',
        value: 'Code of the Population Authority Clerk'
    },
    // 19
    {
        label: 'N_General_SignUp_lobby_info_14',
        value: 'biometric passport details information'
    },
    // 20
    {
        label: 'N_General_SignUp_lobby_info_15',
        value: 'biometric ID details information'
    },
];

declare var _siteSettings: any;

const RegistrationOptionsComponent = props =>  {
    
    const ctx = useContext(LoginContext);

    const [showListTwoIdentefication, setShowListTwoIdentefication] = useState(false);
    const [showListBiometricPassport, setShowListBiometricPassport] = useState(false);
    const [showListTwoIdenteficationMobile, setShowListTwoIdenteficationMobile] = useState(false);
    const [showListBiometricPassportMobile, setShowListBiometricPassportMobile] = useState(false);


    const handleTwoIdnClick = () => {   
        if(ctx.PreRegUser.length > 0){
            window.location.href = _siteSettings.signupLink + 
                                        "&userid=" + ctx.PreRegUser[0] +
                                        "&usermail=" + ctx.PreRegUser[1] + 
                                        "&userphone=" + ctx.PreRegUser[2] 
        }  
        else{
            window.location.href = _siteSettings.signupLink;
        }   
        
    };

    const handleBioIdClick = () => {
        window.location.href = _loginMethodIsraelSmartCardUrl;
    };

    const handleToggleClick = () => {       
        setShowListTwoIdentefication(!showListTwoIdentefication);
    }

    const handleToggleClick2 = () => {       
        setShowListBiometricPassport(!showListBiometricPassport);
    }

    const handleToggleClickMobile = () => {
        var width = window.screen.width;
        if(width <= 576){            
            setShowListTwoIdenteficationMobile(!showListTwoIdenteficationMobile);
        }
    }

    const handleToggleClick2Mobile = () => {
        var width = window.screen.width;
        if(width <= 576){           
            setShowListBiometricPassportMobile(!showListBiometricPassportMobile);
        }
    }
    
    const onPreRegProcessClick = () => {
        ctx.displayRegForm(false); 
        ctx.setSkipMainRegForm(true);                    
    };

    const onPreRegProcessPress = (event) => {
        event.preventDefault();
        if (event.charCode === 13){
            onPreRegProcessClick();
        }
    };

   
    return (
    
        <>            
            <ToggleTwoIdenteficationMobile showListTiMobile={showListTwoIdenteficationMobile} onCloseClicked={handleToggleClickMobile}/>
            <ToggleBiometricPassportMobile showListBpMobile={showListBiometricPassportMobile} onCloseClicked={handleToggleClick2Mobile}/>

            <div className='linkContainer'>
                <div className='sqwerLink flexContainer' onClick={handleToggleClickMobile}>
                        <img src={twoIdentefication}></img>
                        <div className='registraionOption'>
                            <h3 id='twoIdnTitle'>{Translate(translateText[1].label)}</h3>
                            <div onClick={handleToggleClick} className='registraionOptionDetails flexContainer'>
                                <div className={showListTwoIdentefication ? 'arrowUp' : 'arrowDown'}></div>
                                <div>{Translate(translateText[2].label)}</div>
                            </div>
                            
                            <ToggleTwoIdentefication showListTi={showListTwoIdentefication} />                            
                        </div>
                        <button id='btnTwoIdn' onClick={handleTwoIdnClick} className='btn btn-primary' aria-describedby="twoIdnTitle">
                            <div className='xsDisplayNone'>{Translate(translateText[0].label)}</div>
                            <div className='registrationArrow'></div>
                        </button>
                </div>
                {/* <div className='sqwerLink flexContainer' onClick={this.handleToggleClick2Mobile}>
                    <img src={biometricPasport}></img>
                        <div className='registraionOption'>
                            <h3>
                                {Translate(translateText[8].label)}
                            </h3>
                            <div onClick={this.handleToggleClick2} className='registraionOptionDetails flexContainer'>
                                <div className={this.state.showListBiometricPassport ? 'arrowUp' : 'arrowDown'}></div>
                                <div>להסבר על דרכון ביומטרי ורכיב NFC</div>
                            </div>
                            
                            <ToggleBiometricPassport showListBp={this.state.showListBiometricPassport} />
                        </div>
                        <button onClick={()=>window.location.href = _siteSettings.signupLinkBiometricP} className='btn btn-primary'>
                            <div className='xsDisplayNone'>{Translate(translateText[0].label)}</div>
                            <div className='registrationArrow'></div>
                        </button>
                </div> */}
                <div className='sqwerLink flexContainer xsDisplayNone'>
                    <img src={biometricId}></img>
                        <div className='registraionOption'>
                            <h3 id='bioIdTitle'>{Translate(translateText[9].label)}</h3>
                            
                            <div className='registrationExplanation'>
                                {Translate(translateText[9].label)}
                                
                            </div>
                        </div>
                        <button id='btnBioId' onClick={handleBioIdClick} className='btn btn-primary' aria-describedby="bioIdTitle">
                            {Translate(translateText[0].label)}
                        </button>
                </div> 
                <div className='smallSqwerLink flexContainer xsDisplayNone'>
                    <span>{Translate('N_Login_SignUp_Options_Quest')}</span>
                    <a id='skipWizard' 
                        className='preRegProcessLink' 
                        onClick={onPreRegProcessClick}
                        onKeyPress={onPreRegProcessPress}
                        tabIndex={0}               
                    >
                        {Translate('N_Login_SignUp_Options_Desc')}
                    </a>                      
                </div>               
            </div>                        
        </>
    );    
}
export default RegistrationOptionsComponent;